// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/storage/uploads/';

export const apiUrl = 'https://theomsaga.com/apibackend/apis/';
export const assetsUrl = 'https://theomsaga.com/apibackend/storage/app/public/uploads/';